export default "__VITE_ASSET__B1uj1Rnr__"